import React, { useEffect, useState } from 'react'
import Honeybadger from 'honeybadger-js'

import FeatureTourModal from 'pages/shared/FeatureTourModal'

import useActiveFeatureTour from 'hooks/useActiveFeatureTour'
import { useSessionContext } from 'hooks/SessionContext'

import Api from 'services/api'
import Brand from 'helpers/brand'

import GA4 from 'helpers/ga4'

const FeatureTour = () => {
  const { featureTour, isFeatureTourLoaded } = useActiveFeatureTour()
  const brand = Brand.current()
  const { session } = useSessionContext()

  const [open, setOpen] = useState(false)

  useEffect(() => {
    let cancelled = false
    if (isFeatureTourLoaded && featureTour && session.currentRole !== 'admin' && !session.isImpersonating) {
      Api.FeatureTourUserRead.list(brand).then((res) => {
        if (cancelled) return
        const featureTourIds = res.featureTourIds

        if (!featureTourIds.includes(featureTour.id)) {
          setOpen(true)
        }
      })
    }
    return () => { cancelled = true }
  }, [brand, featureTour, isFeatureTourLoaded, session])

  const closeCallback = (buttonClicked, featureTourId) => {
    Api.FeatureTourUserRead.create({ featureTourId, brand })
      .then(() => {
        GA4.sendEvent({
          category: 'Main Navigation',
          action: 'Feature Carousel Closed',
          label: buttonClicked
        })
        setOpen(!open)
      }).catch((e) => {
        Honeybadger.notify('Error on skipping feature tour', { context: e })
      })
  }

  if (!featureTour) { return null }

  const featureTourId = featureTour.id || ''
  const title = featureTour.title || ''
  const message = featureTour.message || ''
  const siteMessages = featureTour.siteMessages || []

  return (
    <FeatureTourModal
      open={open}
      title={title}
      message={message}
      siteMessages={siteMessages}
      closeCallback={(buttonClicked) => closeCallback(buttonClicked, featureTourId)}
    />
  )
}

export default FeatureTour
